// utils/pasteTableData.js
import { isFieldDisabled, isFieldReadOnly } from "./fieldRules";
import { applyCalculatedFields } from "./applyCalculatedFields";

export const pasteTableData = ({
  clipboardText,
  startRowIndex,
  startColumnIndex,
  rows,
  visibleColumns,
  config,
}) => {
  if (!clipboardText) {
    return rows;
  }

  // Excel normally gives:
  // column1 \t column2 \t column3
  // row2    \t row2      \t row2

  const pastedRows = clipboardText
    .replace(/\r/g, "")
    .split("\n")
    .filter((row) => row.trim() !== "")
    .map((row) => row.split("\t"));

  if (!pastedRows.length) {
    return rows;
  }

  const updatedRows = [...rows];

  pastedRows.forEach((pasteRow, pasteRowIndex) => {
    const targetRowIndex = startRowIndex + pasteRowIndex;

    // Create row if required
    if (!updatedRows[targetRowIndex]) {
      updatedRows[targetRowIndex] = {};
    }

    const currentRow = {
      ...updatedRows[targetRowIndex],
    };

    pasteRow.forEach((value, pasteColumnIndex) => {
      const targetColumnIndex = startColumnIndex + pasteColumnIndex;

      const column = visibleColumns[targetColumnIndex];

      if (!column) return;

      const fieldName = column.Field;

      // --------------------------------
      // READ ONLY
      // --------------------------------
      if (isFieldReadOnly(fieldName, config)) {
        return;
      }

      // --------------------------------
      // DISABLED
      // --------------------------------
      if (isFieldDisabled(fieldName, currentRow, config)) {
        return;
      }

      currentRow[fieldName] = value?.trim?.() ?? value;
    });

    // --------------------------------
    // Calculated fields
    // --------------------------------
    updatedRows[targetRowIndex] = applyCalculatedFields(
      currentRow,
      config?.computedFields,
    );
  });

  return updatedRows;
};
